import { DOWN_ARROW, OBSCURE_WEATHER_SYMBOL, UP_ARROW, } from "@poscon/shared-types";
import { BaseKeyboardEvent } from "./baseKeyboardEvent.js";
export class EramKeyboardEvent extends BaseKeyboardEvent {
    token;
    getToken() {
        const event = this.nativeEvent;
        if (!this.isNumpadKey && !this.useDigitsAsNumpad) {
            switch (event.code) {
                case "Digit1":
                    return OBSCURE_WEATHER_SYMBOL;
                case "Digit2":
                    return UP_ARROW;
                case "Digit3":
                    return DOWN_ARROW;
                case "Digit0":
                    return "*";
            }
            if (this.isDigit) {
                return null;
            }
        }
        if (event.key.length === 1) {
            return event.key.toUpperCase();
        }
        return null;
    }
    get useDigitsAsNumpad() {
        return this.alt !== this.capsLock;
    }
    clear = false;
    constructor(event) {
        super(event);
        this.token = this.getToken();
    }
}
//# sourceMappingURL=eramKeyboardEvent.js.map